export default (stringWithHTML) => {
  const doc = new DOMParser().parseFromString(stringWithHTML, 'text/html')
  return doc.body.textContent || ""
}